import { Button, Stack, Typography } from "@mui/material"
import Dialog from "components/common/dialog/dialog"
import { useIsBreakpointUp } from "hooks/breakpoint"
import { useDialog } from "hooks/dialog"
import mixpanel from "mixpanel-browser"
import { useTranslation } from "react-i18next"
import { PrimaryTile } from "styles/common/tile"

import AddNewClass from "../../addNewClass/AddNewClass"
import SendTransactionForm from "./sendTransactionForm"
import { useQuickActionValidation } from "./useQuickActionValidation"

const QuickAction = () => {
  const isTablet = useIsBreakpointUp("tablet")
  const { t } = useTranslation()
  const { isOpen, handleOpen, handleClose } = useDialog()

  const {
    isLoadingValidation,
    canOpenSendTransaction,
    handleSendTransactionClick,
    isAddClassDialogOpen,
    handleCloseAddClassDialog,
    newClassState,
    setNewClassState,
    createNewClass,
    isLoadingCreateClass,
  } = useQuickActionValidation()

  const handleSendTransactionButtonClick = () => {
    const shouldOpenDialog = handleSendTransactionClick()

    if (shouldOpenDialog && canOpenSendTransaction) {
      handleOpen()
      mixpanel.track("send_quick_transaction", {
        action: "open",
      })
    }
  }

  return (
    <>
      <PrimaryTile width="100%" py="16px" px={isTablet ? "24px" : "16px"}>
        <Stack rowGap="16px">
          <Typography variant="subtitle1" color="mockup.neutral10">
            {t("dashboard.quickAction")}
          </Typography>
          <Button
            onClick={handleSendTransactionButtonClick}
            disabled={isLoadingValidation}
          >
            {t("dashboard.sendTransaction")}
          </Button>
        </Stack>
      </PrimaryTile>

      <SendTransactionForm isOpen={isOpen} onClose={handleClose} />

      <Dialog
        titleText={t("addNewClass.addNewClass")}
        open={isAddClassDialogOpen}
        onClose={handleCloseAddClassDialog}
        desktopMaxWidth="534px"
        tabletMaxWidth="534px"
        actionAcceptText={
          isLoadingCreateClass
            ? t("addNewClass.creatingClass")
            : t("addNewClass.save")
        }
        actionAcceptButtonProps={{
          type: "submit",
          disabled: isLoadingCreateClass,
          form: "form",
        }}
      >
        <AddNewClass
          state={newClassState}
          setState={setNewClassState}
          id="form"
          createNewClass={createNewClass}
          allClasses={[]}
          userInfo={null}
        />
      </Dialog>
    </>
  )
}

export default QuickAction
